export default "__VITE_ASSET__e05604a7__"